// URL search params of the BOM and routing list pages. Kept apart from the
// page module so the route config (entry chunk) does not pull the page in.
import { isVersionFilter, type VersionFilter } from "./api";
import { isOrderStatusFilter, type OrderStatusFilter } from "./orders";
import { productionOrderListColumns, versionListColumns } from "@patronix/domain/list";
import { viewSearch, type ViewSearch } from "@/lib/listView";

export interface VersionSearch extends ViewSearch {
  status: VersionFilter;
  q: string;
  id?: string | undefined;
  /** The import panel is open (replaces the version detail). */
  import?: true | undefined;
}

export function validateVersionSearch(raw: Record<string, unknown>): VersionSearch {
  const s: VersionSearch = {
    status: isVersionFilter(raw.status) ? raw.status : "current",
    q: typeof raw.q === "string" ? raw.q.slice(0, 100) : "",
  };
  if (typeof raw.id === "string" && raw.id) s.id = raw.id;
  if (raw.import === true || raw.import === "true") s.import = true;
  return { ...s, ...viewSearch(versionListColumns, raw) };
}

export interface OrderSearch extends ViewSearch {
  status: OrderStatusFilter;
  q: string;
  po?: string | undefined;
}

export function validateOrderSearch(raw: Record<string, unknown>): OrderSearch {
  const s: OrderSearch = {
    status: isOrderStatusFilter(raw.status) ? raw.status : "open",
    q: typeof raw.q === "string" ? raw.q.slice(0, 100) : "",
  };
  if (typeof raw.po === "string" && raw.po) s.po = raw.po;
  return { ...s, ...viewSearch(productionOrderListColumns, raw) };
}
